/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Club_Owner_Role_FixedInputs */

const en_us2_club_owner_role_fixed = /** @type {(inputs: Club_Owner_Role_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The club owner's role doesn't change here.`)
};

const pt_br2_club_owner_role_fixed = /** @type {(inputs: Club_Owner_Role_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O papel do dono do clube não muda por aqui.`)
};

const es_419_club_owner_role_fixed = /** @type {(inputs: Club_Owner_Role_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El rol del dueño del club no se cambia aquí.`)
};

const pt_pt2_club_owner_role_fixed = /** @type {(inputs: Club_Owner_Role_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O papel do dono do clube não muda aqui.`)
};

const fr_fr2_club_owner_role_fixed = /** @type {(inputs: Club_Owner_Role_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le rôle du propriétaire du club ne change pas ici.`)
};

const de_de2_club_owner_role_fixed = /** @type {(inputs: Club_Owner_Role_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Rolle des Club-Inhabers ändert sich hier nicht.`)
};

const it_it2_club_owner_role_fixed = /** @type {(inputs: Club_Owner_Role_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il ruolo del proprietario del club non cambia qui.`)
};

/**
* | output |
* | --- |
* | "The club owner's role doesn't change here." |
*
* @param {Club_Owner_Role_FixedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const club_owner_role_fixed = /** @type {((inputs?: Club_Owner_Role_FixedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Club_Owner_Role_FixedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_club_owner_role_fixed(inputs)
	if (locale === "es-419") return es_419_club_owner_role_fixed(inputs)
	if (locale === "pt-PT") return pt_pt2_club_owner_role_fixed(inputs)
	if (locale === "fr-FR") return fr_fr2_club_owner_role_fixed(inputs)
	if (locale === "de-DE") return de_de2_club_owner_role_fixed(inputs)
	if (locale === "it-IT") return it_it2_club_owner_role_fixed(inputs)
	return en_us2_club_owner_role_fixed(inputs)
});
export { club_owner_role_fixed as "club.owner_role_fixed" }